import { Component, Input, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-name-selector',
  templateUrl: './name-selector.component.html',
  styleUrls: ['./name-selector.component.css']
})
export class NameSelectorComponent {
  // Data coming IN from the database
  @Input() allUsers: any[] = []; 
  
  // Data going OUT to main page
  @Output() selectionChange = new EventEmitter<any[]>();
  constructor(private eRef: ElementRef) {}
  isOpen = false;
  searchTerm = '';
  selectedUsers: any[] = [];

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  // Logic to add or remove a person
  toggleUser(user: any) {
    const index = this.selectedUsers.findIndex(u => u.id === user.id);
    if (index > -1) {
      this.selectedUsers.splice(index, 1); // Remove
    } else {
      this.selectedUsers.push(user); // Add
    }
    this.selectionChange.emit(this.selectedUsers);
  }
  // NEW METHOD: Removes a tag without toggling the dropdown menu
  removeUser(user: any, event: Event) {
    event.stopPropagation(); // Prevents the dropdown from opening/closing
    this.toggleUser(user);   // Re-uses your existing logic to remove the user
  }
  // Check if a user is currently selected
  isSelected(user: any): boolean {
    return this.selectedUsers.some(u => u.id === user.id);
  }

  // Filter the list based on what you type
  get filteredUsers() {
    return this.allUsers.filter(user => 
      user.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }
  // This listener runs on EVERY click anywhere on the page
  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    // If the click happened OUTSIDE this component...
    if (!this.eRef.nativeElement.contains(event.target)) {
      // ...close the dropdown
      this.isOpen = false;
    }
  }
}